import React from 'react';
import Layout from '@components/layout/Layout';
import { getTranslationCache } from '@repo/sanity-static-localization-provider-library';
import {
  InternationalContext,
  useInternationalHelper,
} from '@repo/gatsby-localization-helpers';
import { SiteSettingsProvider } from '@repo/contexts/SiteSettingsContext';
import CustomerContextProvider from '@repo/contexts/CustomerContext';
import useSiteSettings from '@components/hooks/useSiteSettings';
import { uiComponentsLocalizationData } from '@repo/static-translations';

const InternationalContextWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const mockTranslationCache = getTranslationCache(
    null,
    uiComponentsLocalizationData
  );

  const staticContentLocalizer = useInternationalHelper(
    'en-us',
    mockTranslationCache,
    uiComponentsLocalizationData
  );

  return (
    <InternationalContext.Provider value={staticContentLocalizer}>
      {children}
    </InternationalContext.Provider>
  );
};

function PageWrapper({ element }: { element: React.ReactElement }) {
  return (
    <InternationalContextWrapper>
      <SiteSettingsProvider
        useSiteSettings={useSiteSettings}
        siteIdentifier="petsafe-support"
      >
        <CustomerContextProvider shopifySettings={null}>
          <Layout>{element}</Layout>
        </CustomerContextProvider>
      </SiteSettingsProvider>
    </InternationalContextWrapper>
  );
}

export default PageWrapper;
